import { SxStyleFunc } from '@aibees/shared/theme';

export const optionTitleParentheses: SxStyleFunc<{ isNew: boolean }> = ({
  isNew,
}) => ({
  color: (p) => (isNew ? p.palette.success[600] : p.palette.common.black),
});
